module.exports = __webpack_public_path__ + "img/VancouverFlughafen.e98fd18e.jpg";